import { render, staticRenderFns } from "./ReservationApp.vue?vue&type=template&id=4cffe82e&scoped=true&"
import script from "./ReservationApp.vue?vue&type=script&lang=js&"
export * from "./ReservationApp.vue?vue&type=script&lang=js&"
import style0 from "./ReservationApp.vue?vue&type=style&index=0&id=4cffe82e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cffe82e",
  null
  
)

export default component.exports